import React from 'react';
import { Box, Paper, Typography, Stack, Divider, IconButton } from '@mui/material';
import { Phone, Email, Business, PeopleAltOutlined, Add, Person, Article } from '@mui/icons-material';
import { sxConfig } from './workspace.style';

const ContactSidebar = ({ selectedValues }) => {
  return (
    <Paper
      sx={{
        ...sxConfig.card,
        p: 2,
      }}
    >
      {selectedValues.company && (
        <Box mb={3}>
          <Stack direction="row" spacing={1.5} alignItems="center" mb={2}>
            <IconButton
              sx={{
                m: 0,
                p: 0.5,
                background: '#4ade80',
                borderRadius: 2,
                '&:hover': {
                  bgcolor: '#38c96d',
                },
              }}
            >
              <Business sx={{ color: 'white' }} />
            </IconButton>
            <Typography fontWeight={700} sx={{ wordBreak: 'break-all' }}>
              {selectedValues.company.name}
            </Typography>
          </Stack>
          <Box>
            {selectedValues.company?.phoneNumber && (
              <Stack direction="row" spacing={1} mt={1}>
                <Phone fontSize="small" />
                <Typography color="primary.main">{selectedValues.company.phoneNumber}</Typography>
              </Stack>
            )}
            {selectedValues.company?.email && (
              <Stack direction="row" spacing={1} mt={1}>
                <Email fontSize="small" />
                <Typography color="primary.main">{selectedValues.company.email}</Typography>
              </Stack>
            )}
          </Box>
        </Box>
      )}
      <Box mb={3}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
          <Stack direction="row" spacing={1.5} alignItems="center">
            <IconButton
              sx={{
                m: 0,
                p: 0.5,
                background: '#ffbb29',
                borderRadius: 2,
                '&:hover': {
                  bgcolor: '#ecad24',
                },
              }}
            >
              <PeopleAltOutlined sx={{ color: 'white' }} />
            </IconButton>
            <Typography fontWeight={700}>Kapcsolatok</Typography>
          </Stack>
          <IconButton>
            <Add />
          </IconButton>
        </Stack>
        {selectedValues.company?.companyContact?.map((c) => (
          <>
            <Stack direction="row" spacing={1} mt={1}>
              <Person fontSize="small" />
              <Typography fontWeight={700}>{c.name}</Typography>
            </Stack>
            <Typography pl={3.5} color="text.secondary">
              {c.role}
            </Typography>
            {c.phoneNumber && (
              <Stack direction="row" spacing={1} mt={1}>
                <Phone fontSize="small" />
                <Typography color="primary.main">{c.phoneNumber}</Typography>
              </Stack>
            )}
            {c.email && (
              <Stack direction="row" spacing={1} mt={1}>
                <Email fontSize="small" />
                <Typography color="primary.main">{c.email}</Typography>
              </Stack>
            )}
            <Divider sx={{ my: 2 }} />
          </>
        ))}
      </Box>
      <Box>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
          <Stack direction="row" spacing={1.5} alignItems="center">
            <IconButton
              sx={{
                m: 0,
                p: 0.5,
                background: '#6694f7',
                borderRadius: 2,
                '&:hover': {
                  bgcolor: '#4D7FE8',
                },
              }}
            >
              <Article sx={{ color: 'white' }} />
            </IconButton>
            <Typography fontWeight={700}>Adatlapok</Typography>
          </Stack>
          <IconButton>
            <Add />
          </IconButton>
        </Stack>
      </Box>
    </Paper>
  );
};

export default ContactSidebar;
